import { render, staticRenderFns } from "./PostsListCard.vue?vue&type=template&id=48f86c22"
import script from "./PostsListCard.vue?vue&type=script&lang=ts"
export * from "./PostsListCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports